import React from 'react'
import BreadCrumComponent from '../BreadCrumComponent';
import img_success from '../../../assets/images/ilustraciones/img-success.svg';
import img_error from '../../../assets/images/ilustraciones/img-error.svg';

class AvisoImportDocumento extends React.Component {

    constructor(props) {
        super(props);

        let data = props.location.state;

        const { tipoDocumento, resultado } = props.match.params;

        this.state = {

            nombreDocumento: data?.nombreDocumento,
            destinatario: data?.destinatario,
            fechaImportacionLote: data?.fechaImportacionLote,
            formato: data?.formato,
            errorDetalle: data?.errorDetalle,
            backURL: data?.backURL,
            urlSiguiente: data?.urlSiguiente,
            tipoDocumento,
            resultado
        };

    }


    handleContinuar = () => {
        this.props.history.push(this.state.urlSiguiente);
    }

    handleLoHareLuego = () => {
        this.props.history.push('/bandeja/pendientes');
    }

    getConfig = () => {
        const {
            tipoDocumento,
            nombreDocumento,
            destinatario,
            descripcionLote,
            fechaImportacionLote,
            errorDetalle,

        } = this.state;

        const estructuraPantallaError = {
            subtitle: 'Ha ocurrido un error',
            cardInfo: [
                { label: 'Concepto del documento', content: nombreDocumento || '--' },
                { label: 'Destinatario', content: destinatario || '--' },
                { label: 'Detalle del error', content: errorDetalle || '--' }
            ],
            breadcrumb: [
                { label: 'Importar documento', path: '' },
                { label: 'Resultados de la operación', path: '' }
            ]
        };

        if (this.state.resultado === 'error') {
            return estructuraPantallaError;
        }

        switch (tipoDocumento) {
            case 'tramite':
                return {
                    subtitle: '¡Su solicitud fue generada exitosamente!',
                    cardInfo: [
                        { label: 'Documento generado', content: nombreDocumento },
                        {
                            label: 'Destinatario(s)',
                            content: (
                                <ul className="txt">
                                    {(destinatario || []).map((d, idx) => (
                                        <li key={idx}>{d}</li>
                                    ))}
                                </ul>
                            )
                        }
                    ],
                    breadcrumb: [
                        { label: 'Nueva solicitud', path: '' },
                        { label: nombreDocumento, path: '' },
                        { label: 'Resultados de la operación', path: '' }
                    ]
                };


            case 'documento': {
                return {
                    subtitle: '¡Haz importado el documento exitosamente!',
                    cardInfo: [
                        { label: 'Concepto del documento', content: nombreDocumento || '--' },
                        { label: 'Destinatario', content: destinatario || '--' }
                    ],
                    breadcrumb: [
                        { label: 'Importar documento', path: '' },
                        { label: 'Resultados de la operación', path: '' }
                    ]
                };
            }

            default:
                return {
                    subtitle: '¡Haz importado el documento exitosamente!',
                    cardInfo: [
                        { label: 'Concepto del documento', content: nombreDocumento || '--' },
                        { label: 'Destinatario', content: destinatario || '--' }
                    ],
                    breadcrumb: [
                        { label: 'Importar documento', path: '' },
                        { label: 'Resultados de la operación', path: '' }
                    ]
                };
        }
    };


    renderResumen = () => {
        const config = this.getConfig();

        return (
            <div className="container-flex container-md">
                <div className="col">
                    <h1 className="section__subtitle-sm">{config.subtitle}</h1>
                    <div className="card">
                        <h3 className="card-title">Aquí tienes un resumen</h3>
                        {config.cardInfo.map((info, idx) => (
                            <div className="card-info" key={idx}>
                                <span className="label">{info.label}</span>
                                <span className="txt">{info.content}</span>
                            </div>
                        ))}
                    </div>

                    <div className="actions">
                        
                        <button onClick={this.handleContinuar} className="btn-medium btn-primary">
                            {this.state.resultado === 'error' ? "Volver a intentar" : "Continuar firmando"}
                        </button>

                        {this.state.resultado === 'error' &&
                            <button onClick={this.handleLoHareLuego} className="btn-medium btn-link">
                                Lo haré luego
                            </button>
                        }

                    </div>
                </div>

                <div className="col">
                    <div className="illustration">
                        <img
                            src={this.state.resultado === 'error' ? img_error : img_success}
                            className="img-fluid"
                            alt={this.state.resultado === 'error' ? 'action_error' : 'action_success'}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const config = this.getConfig();

        return (
            <div className="template-base">
                <header className="component-header">
                    <div className="page-container">
                        <BreadCrumComponent
                            backUrl={this.state.backURL}
                            breadcrumbs={config.breadcrumb}
                        />
                    </div>
                </header>

                <div className="wrapperContent">
                    <div className="component-advice">
                        <div className="page-container">
                            {this.renderResumen()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default AvisoImportDocumento